
import { defineComponent, PropType } from 'vue';
import elementIds from '@/const/elementIds.json';
import IncrediTextInput from '../inputs/incrediTextInput.vue';
import actionMenuPortalContainer from './agents-menu/components/action-menu-portal-container.vue';
import { SelectedAgent } from './AgentActionMenu.types';

export default defineComponent({
  components: { actionMenuPortalContainer, IncrediTextInput },
  props: {
    buildCacheSettings: {
      type: Object as PropType<SelectedAgent['buildCacheSettings']>,
      default: null,
    },
  },
  setup() {
    return { elementIds };
  },
  data() {
    return {
      dirty: {
        cacheFolder: false,
        databaseFolder: false,
      },
      cacheFolder: '' as string | undefined | null,
      databaseFolder: '' as string | undefined | null,
    };
  },
  created() {
    if (this.buildCacheSettings) {
      this.cacheFolder = this.buildCacheSettings.cacheFolder;
      this.databaseFolder = this.buildCacheSettings.databaseFolder;
    }
  },
  methods: {
    validatePath(path: string) {
      const regex = new RegExp('^[a-z]:(\/|\\\\)([a-zA-Z0-9_ \-]+\\1)*[a-zA-Z0-9_ @\-]+\?', 'gi'); // eslint-disable-line
      return regex.test(path) || 'Invalid folder path';
    },
    onSubmit() {
      (this.$refs['acfl--form'] as any).validate().then((success: boolean) => {
        if (success && (Object.keys(this.dirty) as Array<keyof typeof this.dirty>).some(key => this.dirty[key])) {
          this.$emit('submitAction', { DatabaseFolder: this.databaseFolder, CacheFolder: this.cacheFolder });
        }
      });
    },
  },
});
